import React from 'react';
import { TrendingUp, CheckCircle } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
import { Link } from 'react-router-dom';

const CO2Exchange = () => {
  const { t, currentLanguage } = useLanguage();

  return (
    <section className="min-h-screen bg-neutral-50 py-12">
      <div className="container-custom max-w-3xl mx-auto">
        <div className="bg-white rounded-2xl shadow-lg p-8 mb-8">
          <div className="flex items-center gap-4 mb-6">
            <TrendingUp className="h-10 w-10 text-primary-500" />
            <h1 className="text-2xl md:text-3xl font-bold text-primary-700">{t('service-exchange')}</h1>
          </div>
          <p className="text-lg text-neutral-700 mb-6">
            {t('service-exchange-desc')}
          </p>
          <ul className="space-y-3 mb-8">
            <li className="flex items-center gap-2 text-green-700 font-medium">
              <CheckCircle className="h-5 w-5 text-primary-500" /> {t('service-exchange-feature-1')}
            </li>
            <li className="flex items-center gap-2 text-green-700 font-medium">
              <CheckCircle className="h-5 w-5 text-primary-500" /> {t('service-exchange-feature-2')}
            </li>
            <li className="flex items-center gap-2 text-green-700 font-medium">
              <CheckCircle className="h-5 w-5 text-primary-500" /> {t('service-exchange-feature-3')}
            </li>
            <li className="flex items-center gap-2 text-green-700 font-medium">
              <CheckCircle className="h-5 w-5 text-primary-500" /> {t('service-exchange-feature-4')}
            </li>
          </ul>
          <div className="flex flex-col md:flex-row gap-4">
            <Link to={`/${currentLanguage}/contact`} className="btn-primary text-center">{t('form-submit')}</Link>
            <Link to={`/${currentLanguage}`} className="btn-secondary text-center">{t('back-to-home')}</Link>
          </div>
        </div>
        <div className="bg-primary-50 rounded-xl p-6 text-primary-800 text-center font-semibold">
          {t('service-exchange-desc')}
        </div>
      </div>
    </section>
  );
};

export default CO2Exchange; 